import React from 'react';
import { Check, MessageCircle, X, Star, Zap, Clock } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
const plans = [{
  name: 'Starter',
  price: '€150',
  originalPrice: '€750',
  subtitle: 'One-time payment',
  badge: null,
  highlighted: false,
  features: [{
    text: 'Template-Based Design',
    included: true
  }, {
    text: 'Mobile Responsive',
    included: true
  }, {
    text: 'Contact Form',
    included: true
  }, {
    text: '6 Months of Hosting',
    included: true
  }, {
    text: '50 AI Editing Requests/mo',
    included: true
  }, {
    text: '1 Round of Revisions',
    included: true
  }, {
    text: 'Email Support',
    included: true
  }, {
    text: 'WhatsApp Integration',
    included: false
  }, {
    text: 'Hobby Plan Included',
    included: false
  }, {
    text: 'Direct WhatsApp Support',
    included: false
  }],
  cta: 'Get the €150 Package',
  whatsappText: 'Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC150%20Starter%20website%20package.%20My%20business%20is%3A%20____'
}, {
  name: 'Dublin Launch',
  price: '€249',
  originalPrice: '€999',
  subtitle: 'One-time payment',
  badge: 'Most Popular',
  highlighted: true,
  features: [{
    text: 'Custom Design & Build',
    included: true
  }, {
    text: 'Mobile Responsive',
    included: true
  }, {
    text: 'WhatsApp Integration',
    included: true
  }, {
    text: '1-Year Hobby Plan ($180 value)',
    included: true
  }, {
    text: '100 AI Editing Requests/mo',
    included: true
  }, {
    text: '5 Rounds of Revisions',
    included: true
  }, {
    text: '1 Year of Fast Hosting',
    included: true
  }, {
    text: '1 Year of Direct Support',
    included: true
  }, {
    text: 'Contact Form + Google Maps',
    included: true
  }, {
    text: 'Basic Analytics Setup',
    included: true
  }],
  cta: 'Get the €249 Package',
  whatsappText: 'Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC249%20website%20package.%20My%20business%20is%3A%20____'
}, {
  name: 'Premium',
  price: '€499',
  originalPrice: '€2,500',
  subtitle: 'One-time payment',
  badge: 'Best Value',
  highlighted: false,
  features: [{
    text: 'Multi-Page Website (up to 5 pages)',
    included: true
  }, {
    text: 'Custom Design & Build',
    included: true
  }, {
    text: 'Advanced SEO Setup',
    included: true
  }, {
    text: '1-Year Pro Plan',
    included: true
  }, {
    text: '200 AI Editing Requests/mo',
    included: true
  }, {
    text: '5 Rounds of Revisions',
    included: true
  }, {
    text: '1 Year of Fast Hosting',
    included: true
  }, {
    text: 'Priority Direct Support',
    included: true
  }, {
    text: 'Google Business Profile Setup',
    included: true
  }, {
    text: 'Logo Design Included',
    included: true
  }],
  cta: 'Get the €499 Package',
  whatsappText: 'Hi%2C%20I%27m%20in%20Dublin.%20I%20want%20the%20%E2%82%AC499%20Premium%20website%20package.%20My%20business%20is%3A%20____'
}];
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 px-4 md:px-6 relative overflow-hidden" style={{
    backgroundColor: '#050505'
  }} data-id="element-334">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c9a84c]/8 rounded-full blur-[120px] pointer-events-none" data-id="element-335"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-336">
        <div className="text-center mb-16 reveal" data-id="element-337">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-338">
            Simple, Transparent Pricing
          </h2>
          <p className="text-white/60" data-id="element-339">
            Choose the package that fits your business needs.
          </p>
        </div>

        {/* Special Launch Offer Banner */}
        <div className="max-w-3xl mx-auto mb-16 reveal" data-id="element-340">
          <div className="relative rounded-2xl overflow-hidden" data-id="element-341">
            <div className="absolute inset-0 bg-gradient-to-r from-[#c9a84c]/20 via-[#c9a84c]/10 to-[#c9a84c]/20 blur-sm" data-id="element-342"></div>
            <div className="relative border border-[#c9a84c]/40 rounded-2xl p-8 md:p-10" style={{
            backgroundColor: '#0c0c0c'
          }} data-id="element-343">
              {/* Badge */}
              <div className="flex justify-center mb-6" data-id="element-344">
                <div className="inline-flex items-center space-x-2 bg-[#c9a84c] px-4 py-1.5 rounded-full" data-id="element-345">
                  <Zap className="w-4 h-4 text-black" data-id="element-346" />
                  <span className="text-black font-bold text-sm uppercase tracking-wider" data-id="element-347">
                    Special Launch Offer – Limited Time
                  </span>
                </div>
              </div>

              {/* Price Comparison */}
              <div className="text-center mb-6" data-id="element-348">
                <div className="flex items-center justify-center space-x-4 mb-2" data-id="element-349">
                  <span className="text-2xl md:text-3xl text-white/40 line-through font-medium" data-id="element-350">
                    €999+
                  </span>
                  <span className="text-white/30 text-lg" data-id="element-351">→</span>
                  <span className="text-4xl md:text-5xl font-bold gold-gradient-text" data-id="element-352">
                    €249
                  </span>
                </div>
                <p className="text-white/50 text-sm" data-id="element-353">
                  Typical Agency Website Price vs. Our Launch Price
                </p>
              </div>

              {/* Description */}
              <div className="space-y-4 text-center max-w-xl mx-auto" data-id="element-354">
                <p className="text-white/80 leading-relaxed" data-id="element-355">
                  You're getting a fully built, professionally designed website
                  installed on your own domain — plus a{' '}
                  <span className="text-[#c9a84c] font-semibold" data-id="element-356">
                    1-Year MagicPatterns Hobby Plan (worth $180)
                  </span>{' '}
                  included.
                </p>
                <p className="text-white/60 text-sm leading-relaxed" data-id="element-357">
                  Most businesses in Ireland pay €1,000 or more for a custom
                  website. We're offering this at €249 as a limited launch
                  package to build our portfolio and partner with selected
                  businesses.
                </p>
              </div>

              {/* Urgency Footer */}
              <div className="mt-6 pt-6 border-t border-white/10 flex items-center justify-center space-x-2" data-id="element-358">
                <Clock className="w-4 h-4 text-[#c9a84c] animate-pulse" data-id="element-359" />
                <p className="text-[#c9a84c] text-sm font-medium" data-id="element-360">
                  Once the promotional slots are filled, pricing returns to
                  standard market rates.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-start" data-id="element-361">
          {plans.map((plan, idx) => <div key={idx} className={`relative rounded-2xl overflow-hidden reveal flex flex-col ${plan.highlighted ? 'gold-border-card gold-glow-strong md:-mt-4 md:mb-0' : 'border border-white/[0.08]'}`} style={{
          backgroundColor: '#0a0a0a',
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-362">
              {/* Badge / Header */}
              {plan.highlighted ? <div className="bg-[#c9a84c] py-2.5 text-center flex items-center justify-center space-x-2" data-id="element-363">
                  <Star className="w-4 h-4 text-black fill-black" data-id="element-364" />
                  <span className="text-black font-bold text-sm uppercase tracking-wider" data-id="element-365">
                    {plan.badge}
                  </span>
                  <Star className="w-4 h-4 text-black fill-black" data-id="element-366" />
                </div> : plan.badge ? <div className="bg-white/[0.05] py-2.5 text-center border-b border-white/[0.06]" data-id="element-367">
                  <span className="text-white/60 font-medium text-sm uppercase tracking-wider" data-id="element-368">
                    {plan.badge}
                  </span>
                </div> : <div className="bg-white/[0.03] py-2.5 text-center border-b border-white/[0.06]" data-id="element-369">
                  <span className="text-white/40 font-medium text-sm uppercase tracking-wider" data-id="element-370">
                    {plan.name}
                  </span>
                </div>}

              {/* Content */}
              <div className="p-6 md:p-8 flex flex-col flex-1" data-id="element-371">
                {/* Plan name (if badge shown in header) */}
                {(plan.badge || plan.highlighted) && <p className="text-white/60 text-sm font-medium uppercase tracking-wider mb-2" data-id="element-372">
                    {plan.name}
                  </p>}

                {/* Price */}
                <div className="mb-1" data-id="element-373">
                  <span className="text-lg text-white/40 line-through mr-3" data-id="element-374">
                    {plan.originalPrice}
                  </span>
                  <span className={`text-5xl font-bold ${plan.highlighted ? 'gold-gradient-text' : 'text-white'}`} data-id="element-375">
                    {plan.price}
                  </span>
                </div>
                <p className="text-white/50 text-sm mb-8" data-id="element-376">{plan.subtitle}</p>

                {/* Features */}
                <ul className="space-y-3 mb-8 flex-1" data-id="element-377">
                  {plan.features.map((feature, i) => <li key={i} className="flex items-start space-x-3" data-id="element-378">
                      {feature.included ? <div className="bg-[#c9a84c]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-379">
                          <Check className="w-3.5 h-3.5 text-[#c9a84c]" data-id="element-380" />
                        </div> : <div className="bg-white/5 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-381">
                          <X className="w-3.5 h-3.5 text-white/20" data-id="element-382" />
                        </div>}
                      <span className={feature.included ? 'text-white/85 text-sm' : 'text-white/30 text-sm line-through'} data-id="element-383">
                        {feature.text}
                      </span>
                    </li>)}
                </ul>

                {/* CTA */}
                <div className="space-y-3 mt-auto" data-id="element-384">
                  <a href={`https://wa.me/36707559881?text=${plan.whatsappText}`} target="_blank" rel="noopener noreferrer" className={`w-full font-bold py-3.5 rounded-lg transition-all transform hover:scale-[1.02] flex items-center justify-center space-x-2 ${plan.highlighted ? 'bg-[#25D366] hover:bg-[#20bd5a] text-white shadow-lg shadow-green-900/20' : 'border border-[#c9a84c]/50 text-[#c9a84c] hover:bg-[#c9a84c]/10'}`} data-id="element-385">
                    <MessageCircle className="w-5 h-5" data-id="element-386" />
                    <span data-id="element-387">{plan.cta}</span>
                  </a>

                  {plan.highlighted && <p className="text-[#c9a84c] text-xs font-medium animate-pulse text-center" data-id="element-388">
                      Only 5 spots available this month
                    </p>}
                </div>
              </div>
            </div>)}
        </div>

        <p className="text-center text-xs text-white/30 mt-10 reveal" data-id="element-389">
          Domain purchased separately — or we can handle it for a small extra
          fee
        </p>
      </div>
      <SectionDivider data-id="element-390" />
    </section>;
}